import React, { createContext, useReducer, FC } from 'react';
import {
  GoalsAction,
  goalsReducer,
  GoalsState,
} from '../reducer/goals.reducer';

const initialState = {
  goalsList: [],
  clickedGoal: {},
};

export const GoalsContext = createContext<{
  state: GoalsState;
  dispatch: React.Dispatch<GoalsAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

export const GoalsProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(goalsReducer, initialState);

  return (
    <GoalsContext.Provider value={{ state, dispatch }}>
      {children}
    </GoalsContext.Provider>
  );
};

export default GoalsProvider;
